const palettes = {
  blue4: ['#4f6090', '#5c74b7', '#7b91cc', '#a0afda'],
  yellow4: ['#dfc213', '#f8d815', '#fae562', '#fdf2b2'],
}

export default palettes;